import { Component, Input } from '@angular/core';
import { AvailabilityType } from "../../../dashboard/interfaces/availability-type.interface";

@Component({
  selector: 'app-availability-icon',
  templateUrl: './availability-icon.component.html'
})
export class AvailabilityIconComponent {

  @Input() availability: AvailabilityType
  @Input() size: number;
  sizes: Object;
  
  constructor() {
    this.sizes = {
      1: {
        icon: 'md-18',
        text: 'text-base'
      },
      3: {
        icon: 'md-30',
        text: 'text-xl'
      }
    };
  }

}
